import React from 'react';

/**
 * Scrollable embedded PDF viewer for pitch decks.
 */
const PdfScrollSection = ({ title, src, height = 720 }) => (
  <section className="v3-block v3-pdf-section">
    <h2>{title}</h2>
    <div className="v3-pdf-frame-wrap" style={{ height }}>
      <iframe
        className="v3-pdf-frame"
        src={`${src}#toolbar=1&navpanes=0&scrollbar=1`}
        title={title}
        loading="lazy"
      />
    </div>
    <p className="v3-pdf-fallback">
      <a href={src} target="_blank" rel="noopener noreferrer">
        Open PDF in new tab →
      </a>
    </p>
  </section>
);

export default PdfScrollSection;
